import React from 'react';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';
import StoryContentOptions from 'components/elements/pages/topics/modules/common/StoryContentOptions';
import { formatResultURL } from 'components/utils/helpers';

import './StoryPackage.scss';

const StoryPackage = ({ title, items }) => {
  const stories = items.filter(({ thumbnail }) => !!thumbnail);
  const renderItems = stories.map((item, index) => {
    const path = formatResultURL(item.type, item.id);
    return (
      <div key={item.id || /* istanbul ignore next */ `topic-${index}`} className="topic-list--item">
        <Link to={path} aria-label={item.title || /* istanbul ignore next */ item.id}>
          <img src={item.thumbnail} alt={item.title} />
        </Link>
        <div className="topic-list--item-title">
          <Link to={path} aria-label={item.title || /* istanbul ignore next */ item.id}>{item.title}</Link>
        </div>
        <div className="topic-list--item-summary">
          <Truncate lines={3} ellipsis={'...'}>{item.summary}</Truncate>
        </div>
        <StoryContentOptions {...item} />
      </div>
    );
  });

  return (
    <section className="story-package">
      <div className="story-package-wrapper">
        <h3>{title}</h3>
        {renderItems && renderItems.length && (
          <div className="story-package-container">
            {renderItems}
          </div>)
        }
      </div>
    </section>
  );
};

export default StoryPackage;
